/* import __COLOCATED_TEMPLATE__ from './shared-react-mfe-route-mount.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import * as Sentry from '@sentry/ember';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { getOwner } from '@ember/application';
import { getBrowserTimeZone } from '@dashboard/junk-drawer/utils/time';
import { importBundle } from '@dashboard/junk-drawer/utils/dynamic-import-util';
import { getDatadogRum } from '@square/dashboard-utilities/utils/datadog-rum';
let SharedReactMfeMount = (_class = class SharedReactMfeMount extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "failureMessage", _descriptor, this);
    _initializerDefineProperty(this, "mountFailure", _descriptor2, this);
    _initializerDefineProperty(this, "sharedReactMfe", _descriptor3, this);
    _initializerDefineProperty(this, "userInfo", _descriptor4, this);
    _initializerDefineProperty(this, "datadogRum", _descriptor5, this);
    _initializerDefineProperty(this, "queryClient", _descriptor6, this);
    _initializerDefineProperty(this, "navigationShim", _descriptor7, this);
    _defineProperty(this, "reactRoot", void 0);
  }
  customProps() {
    const {
      browserLanguage,
      countryCode,
      currencyCode,
      employmentToken,
      impersonating,
      loggableSessionToken,
      merchantToken,
      name,
      personToken
    } = this.userInfo;
    return {
      countryCode,
      currencyCode,
      employmentToken,
      eventstreamClient: this.eventstreamClient,
      impersonating,
      locale: browserLanguage,
      merchantProfile: {
        name
      },
      merchantToken,
      personToken,
      sessionId: loggableSessionToken,
      timezone: getBrowserTimeZone(),
      datadogRum: this.datadogRum?.instance,
      queryClient: this.queryClient.instance,
      queryClientV5: this.queryClient.instanceV5,
      ...this.args.bundleProps
    };
  }
  get useDashboardWebMount() {
    // Dynamically lookup the features service to be more compatible with addons or engines
    // consuming junk-drawer that don't inject the feature service.
    const features = getOwner(this).lookup('service:features');
    if (features) {
      const mfes = features.getFlag('dashboard/enabled_dashboard_web_mfes');
      const enabled = Array.isArray(mfes) && mfes.includes(this.args.name);
      return enabled;
    }
    return false;
  }
  get eventstreamClient() {
    return getOwner(this).lookup('eventstream-client:main');
  }
  async setupApp(domElement) {
    try {
      const {
        manifest
      } = await this.sharedReactMfe.getManifest();
      const appSrc = `${manifest.cdnOrigin}/${manifest.main}`;
      await this.mountApplication(appSrc, domElement);
    } catch (e) {
      this.handleMountFailure(e);
    }
  }
  async mountApplication(appSrc, domElement) {
    // babel is giving me guff about dynamic importing
    // from a variable, which we need since the CDN changes
    // for staging and prod. We have to do this hack to please
    // the babel overlords for the time being
    this.navigationShim.start();
    const bundle = await importBundle(appSrc);
    const importedModule = bundle;
    this.reactRoot = await importedModule.bootstrapSharedMfeApp(this.customProps(), domElement);
    getDatadogRum().setViewContextProperty('reactType', this.args.reactType ?? 'page');
  }
  teardownApp() {
    this.reactRoot?.unmount();
    this.reactRoot = undefined;
  }
  handleMountFailure(error) {
    Sentry.captureException(error);
    this.mountFailure = true;
    if (error instanceof Error) {
      this.failureMessage = error.message;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "failureMessage", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "mountFailure", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "sharedReactMfe", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "datadogRum", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "queryClient", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "navigationShim", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "setupApp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setupApp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "teardownApp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "teardownApp"), _class.prototype), _class);
export { SharedReactMfeMount as default };